export const CONSTANTS = {
    CURRENCY:'$'
}